import React from 'react';

// Plain-text content of a children tree, for the hover title on truncated text.
const textOf = (node) => {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(textOf).join('');
  if (node.props) return textOf(node.props.children);
  return '';
};

const Text = ({ style, children, numberOfLines, ellipsizeMode, ...props }) => {
  const convertStyle = (rnStyle) => {
    if (!rnStyle) return {};
    
    const cssStyle = { ...rnStyle };
    
    // Handle flex shorthand if present
    if (typeof cssStyle.flex === 'number') {
      cssStyle.flexGrow = cssStyle.flex;
      cssStyle.flexShrink = 1;
      cssStyle.flexBasis = '0%';
      delete cssStyle.flex;
    }

    // RN lineHeight is in px, but CSS treats a bare number as a font-size
    // multiplier (lineHeight: 18 → 216px lines at 12px font). Values ≤ 3 are
    // kept as multipliers — those callers mean CSS (e.g. lineHeight: 1).
    if (typeof cssStyle.lineHeight === 'number' && cssStyle.lineHeight > 3) {
      cssStyle.lineHeight = `${cssStyle.lineHeight}px`;
    }
    
    // Handle text truncation
    if (numberOfLines === 1) {
      cssStyle.overflow = 'hidden';
      cssStyle.textOverflow = 'ellipsis';
      cssStyle.whiteSpace = 'nowrap';
    } else if (numberOfLines > 1) {
      cssStyle.display = '-webkit-box';
      cssStyle.WebkitLineClamp = numberOfLines;
      cssStyle.WebkitBoxOrient = 'vertical';
      cssStyle.overflow = 'hidden';
    }
    
    return cssStyle;
  };
  
  // Merge array styles first, then convert
  const mergedStyle = Array.isArray(style) 
    ? style.reduce((acc, s) => ({ ...acc, ...s }), {})
    : style;
    
  const processedStyle = convertStyle(mergedStyle);

  // Truncated text gets the full text as a native hover tooltip, unless the
  // caller supplied its own title.
  const title = props.title !== undefined ? props.title
    : numberOfLines >= 1 ? (textOf(children).trim() || undefined) : undefined;

  return (
    <span style={processedStyle} {...props} title={title}>
      {children}
    </span>
  );
};

export default Text;